<template>
    <div class="email-change-verification-page">
        <div class="container">
            <h1>Conferma Modifica Email</h1>
            <p v-if="!successMessage && !errorMessage">Attendi mentre confermiamo la modifica della tua email...</p>

            <!-- Messaggi di successo o errore -->
            <div v-if="successMessage" class="message-container">
                <i class="fa-solid fa-check-circle success-icon"></i>
                <p class="success-message">{{ successMessage }}</p>
                <button @click="openDeepLink" class="btn btn-custom">Continua</button>
            </div>
            <div v-if="errorMessage" class="message-container">
                <i class="fa-solid fa-exclamation-circle error-icon"></i>
                <p class="error-message">{{ errorMessage }}</p>
                <button @click="goToAccountInfo" class="btn btn-custom">Torna alle impostazioni</button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'EmailChangeVerification',
    data() {
        return {
            token: null,
            successMessage: '',
            errorMessage: '',
            isLoading: true
        };
    },
    created() {
        // Recupera il token dall'URL
        this.token = this.$route.query.token || null;

        // Se il token esiste, effettua la richiesta di conferma
        if (this.token) {
            this.confirmEmailChange();
        } else {
            this.errorMessage = 'Token non valido. Non è possibile confermare la modifica dell\'email.';
            this.isLoading = false;
        }
    },
    methods: {
        async confirmEmailChange() {
            try {
                // Effettua la richiesta POST per confermare la modifica email
                const response = await fetch(`https://api.elitefitness.it/api/users/email/confirm?token=${this.token}`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    }
                });

                const data = await response.json();

                if (response.ok && data.success) {
                    this.successMessage = 'La modifica della tua email è stata confermata con successo!';
                    this.errorMessage = '';
                } else {
                    this.errorMessage = data.message || 'Conferma fallita. Token non valido o scaduto.';
                    this.successMessage = '';
                }
            } catch (error) {
                console.error('Email change confirmation failed:', error);
                this.errorMessage = 'Si è verificato un errore durante la conferma. Riprova più tardi.';
                this.successMessage = '';
            } finally {
                this.isLoading = false;
            }
        },
        openDeepLink() {
            const deeplink = "elitefitness://elitefitness.it";
            const iosStore = "https://apps.apple.com/it/app/id6670614281";
            const androidStore = "https://play.google.com/store/apps/details?id=it.utopialabs.elitefitness";
            const fallbackWeb = "https://elitefitness.it"; // opzionale

            const ua = navigator.userAgent || navigator.vendor || window.opera;
            let storeUrl;

            if (/android/i.test(ua)) {
                storeUrl = androidStore;
            } else if (/iPad|iPhone|iPod/.test(ua) && !window.MSStream) {
                storeUrl = iosStore;
            } else {
                // Desktop o altro → vai al sito (puoi cambiarlo in uno store generico)
                window.location = fallbackWeb;
                return;
            }

            const now = Date.now();
            window.location = deeplink;

            setTimeout(() => {
                if (Date.now() - now < 1600) {
                    window.location = storeUrl;
                }
            }, 1500);
        },
        goToAccountInfo() {
            const token = localStorage.getItem('userToken')
            if (token) {
                this.$router.push({ 
                    path: '/account-info', 
                    query: { userToken: token } 
                })
            } else {
                this.$router.push({ path: '/login' })
            }
        }
    }
};
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@400;600;700&display=swap');

.email-change-verification-page {
    font-family: 'Montserrat', sans-serif;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 100vh;
    background-color: #292D7D;
    color: white;
    padding: 2rem;
}

.container {
    max-width: 600px;
    width: 100%;
}

h1 {
    font-family: 'Montserrat', sans-serif;
    font-size: 2rem;
    font-weight: 700;
    color: white;
    margin-bottom: 2rem;
}

.message-container {
    margin-top: 2rem;
}

.success-icon {
    font-size: 4rem;
    color: #28a745;
    margin-bottom: 1rem;
}

.error-icon {
    font-size: 4rem;
    color: #e83539;
    margin-bottom: 1rem;
}

.success-message {
    font-size: 1.2rem;
    color: white;
    margin-bottom: 2rem;
    line-height: 1.6;
}

.error-message {
    font-size: 1.2rem;
    color: #e83539;
    margin-bottom: 2rem;
    line-height: 1.6;
}

.btn-custom {
    font-family: 'Montserrat', sans-serif;
    background-color: #e83539;
    color: white;
    border: none;
    padding: 12px 30px;
    text-transform: uppercase;
    cursor: pointer;
    transition: background-color 0.3s ease;
    border-radius: 0;
    font-size: 1.2rem;
    font-weight: 600;
    margin-top: 1rem;
}

.btn-custom:hover {
    background-color: #cc2e31;
    color: white;
}

@media (max-width: 767px) {
    h1 {
        font-size: 1.5rem;
    }

    .success-icon,
    .error-icon {
        font-size: 3rem;
    }

    .success-message,
    .error-message {
        font-size: 1rem;
    }
}
</style>

